<template>
    <div class="header-category-list" :class="'header-category-list-'+level">
        <Link v-for="cate in categoryList"
           @click="change(cate)"
              class="category-item"
           :class="{
               active: cate.id===currentCate?.id
           }">
            {{ cate.name }}
            <span
                v-if="currentCate?.children?.length && cate.id===currentCate?.id"
                class="triangle"></span>
        </Link>

        <div class="first-level-right-content">
            <slot v-if="level===0" name="first-level-right-content"></slot>
        </div>
    </div>
    <template v-if="level===0 && currentCate?.children?.length">
        <div class="filter-item category">
            <div class="content">
                <div class="parent-category">
                    <DropDownCategory
                        v-if="currentCate?.children?.length"
                        :categoryList="currentCate.children"
                        :level="level+1"
                        :parentCategory="currentCate?{
            id:currentCate.id,
            name:currentCate.name,
        }:null"
                    ></DropDownCategory>
                </div>
            </div>
        </div>
    </template>

    <template v-else>
        <DropDownCategory
            v-if="currentCate?.children?.length"
            :categoryList="currentCate.children"
            :level="level+1"
            :parentCategory="currentCate?{
                id:currentCate.id,
                name:currentCate.name,
            }:null"
        ></DropDownCategory>
    </template>
</template>

<script setup lang="ts">
import {inject, ref, toRef, watch} from "vue";
import Link from "@/Components/Link.vue";

const props = withDefaults(defineProps<{
    categoryList: any[],
    parentCategory: any,
    level?: number,
}>(), {
    level: 0,
})

const categoryList = toRef(props, 'categoryList')

const currentCate = ref(props.parentCategory)

watch(() => categoryList, () => {
    currentCate.value = props.parentCategory
}, {deep: true})

const changeFilterCategoryId = <Function>inject('changeFilterCategoryId')
const changeHeaderData = inject<Function>('changeHeaderData')

categoryList.value.map(function (c) {
    if (c.active) {
        currentCate.value = c

        if (props.level === 0) {
            changeHeaderData('category_id', c?.id || null)
        }
    }
})

const change = (c) => {
    currentCate.value = c
    if (c !== undefined) {

        changeFilterCategoryId(c?.id || null)
    }
}

</script>

<style scoped lang="less">
.header-category-list {
    margin-left: -16px;
    margin-top: 10px;
    overflow: hidden;

    .category-item {
        padding: 10px;
        border-radius: 10px;
        margin-left: 16px;
        display: inline-block;
        margin-top: 5px;
        float: left;

        &.active {
            background: #f6f6f6;
        }
    }

    &.header-category-list-0 {
        padding-bottom: 16px;
        border-bottom: 1px solid #f6f6f6;

        .category-item {
            padding: 10px 14px;
            border: 1px solid #cccccc;
            border-radius: 6px;
            margin-top: 5px;

            &.active {
                color: #FFFFFF;
                background: #2E2E2E;
            }
        }

        .first-level-right-content {
            float: right;
            margin-top: 10px;
        }
    }

    &.header-category-list-2 {
        background: #f6f6f6;
        border-radius: 10px;
        margin-left: 0;
        padding-bottom: 5px;

        .category-item {
            &.active {
                color: #2E2E2E;
            }
        }
    }
}
</style>
